const getters = {
    isAllLoaded: state => {
        return state.isFontsLoaded && state.isDataLoaded
    }
};

export default getters;
